import moment from 'moment-timezone';

const MomentWrapper = ({
    date,
    format,
    className,
}) => {
    const userTimezone = moment.tz.guess();
    const localTime = moment(date).tz(userTimezone).format(format);
    return <span className={className}>{localTime}</span>;
};

export default MomentWrapper;